import flowRight from 'lodash/flowRight'

import appContext from './application-context'
import setupEnvironment from './environment'
import setupGlobalFlash from './global-sf-flash'
import setupResetToDefaultGuard from './reset-to-default-guard'
import setupSolidData from './solid-data'
import setupSolidDataAlterationGuard from './solid-data-alteration-guard'
import setupSolidReconciledStatus from './solid-reconciled-status'
import setupStimulus from './stimulus'
import setupTooltip from './tooltip'
import setupUnreviewConfirmationAdapter from './unreview-confirmation-adapter'
import setupSegmentReadyToastGate from '@app/insights/setup/segment-ready-toast-gate'

export default (): void => {
  flowRight([
    setupEnvironment,
    setupSolidData,
    setupSolidReconciledStatus,
    setupStimulus,
    setupGlobalFlash,
    setupTooltip,
    setupUnreviewConfirmationAdapter,
    setupSolidDataAlterationGuard,
    setupResetToDefaultGuard,
    setupSegmentReadyToastGate,
  ])(appContext)
}
